const getChannelBrandId = () => {
    const isProd = process.env.REACT_APP_NPO_TAG_ENVIRONMENT === 'prod';
    return isProd ? 641115 : 641116;
}

export default getChannelBrandId;
